<app-loading></app-loading>

<ng-template [ngIf]="hasHeader">
  <app-header [currentLang]="currentLang" *ngIf="!customHeader"></app-header>
  <app-landing-header [currentLang]="currentLang" *ngIf="customHeader"></app-landing-header>
</ng-template>

<div class="mainContent">
  <router-outlet></router-outlet>
</div>

<app-footer *ngIf="hasFooter" [customFooter]="customFooter"></app-footer>